
export const getLocalStorage = () => {

    var data = {};
    try {
        data = JSON.parse(localStorage.getItem('account'));
        if (!data) data = {};
    }
    catch (err)
    { }
    return data;
}


export const setLocalStorage = (accessToken, accountNumber, customerBusinessName) => {
    const account = {
        token: accessToken,
        accountNumber: accountNumber,
        customerBusinessName: customerBusinessName
    }

    localStorage.setItem('account', JSON.stringify(account));
}


export const getAccessToken = () => {
    const account = getLocalStorage();
    return account.token;
}

export const getAccountNumber = () => {
    const account = getLocalStorage();
    return account.accountNumber;
}

export const getCustomerBusinessName = () => {
    const account = getLocalStorage();
    return account.customerBusinessName;
}

export const isTokenExpired = (token) => {
    if (!token) return true;
    const arrayToken = token.split('.');
    const tokenPayload = JSON.parse(atob(arrayToken[1]));
    console.log("token exp:" + tokenPayload?.exp);
    return Math.floor(new Date().getTime() / 1000) >= tokenPayload?.exp;
};
